<template>
  <co-button
    :loading="state === 'saving'"
    v-bind="$attrs"
    type="primary"
    size="large"
    class="hr-co-button--save"
    data-test-id="hr-co-button--save"
    :disabled="isDisabled"
  >
    <span v-if="!state || state === 'disabled'">
      {{ t('hr-button-save:save') }}</span
    >
    <span v-if="state === 'saved'"
      ><co-icon class="hr-co-button__icon--check" name="check"></co-icon>
      {{ t('hr-button-save:saved') }}</span
    >
    <span v-if="state === 'saving'"
      ><co-icon class="hr-co-button__icon--spinner" name="spinner"></co-icon>
      {{ t('hr-button-save:saving') }}</span
    >
  </co-button>
</template>

<script>
import { CoIcon, CoButton } from '@deputy/copilot2';
import t from '@/lib/i18next';
const states = [null, 'disabled', 'saving', 'saved'];

export default {
  name: 'hr-button-save',
  components: {
    CoButton,
    CoIcon,
  },
  props: {
    state: {
      type: String,
      default: null,
      validator: (val) => states.includes(val),
      description: `button states (${states.toString()})`,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      t,
    };
  },
};
</script>
<style scoped>
.hr-co-button--save {
  height: 45px;
  padding-top: 4px;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
